import { useCallback } from 'react';

interface UseLoadMoreProps {
  onLoadMore?: () => void;
  hasMore: boolean;
  isLoadingMore: boolean;
}

export const useLoadMore = ({ onLoadMore, hasMore, isLoadingMore }: UseLoadMoreProps) => {
  const handleLoadMore = useCallback(() => {
    if (onLoadMore && hasMore && !isLoadingMore) {
      onLoadMore();
    }
  }, [onLoadMore, hasMore, isLoadingMore]);

  return { handleLoadMore };
};
